module.exports = __webpack_public_path__ + "img/qr-fb.bbf31f6e.png";